

export const remToPx = (rem: number) => {
    const baseFontSize = 16; // Tamaño de fuente raíz en píxeles
    return rem * baseFontSize;
};

export const addCharactersToString = (text: string, totalCharacters: number): string => {
    const finalTotalCharacters = totalCharacters - text.length;
    if (finalTotalCharacters < 0 ) {
      console.warn('La cantidad de espacios no puede ser negativa');
      return text;
    }
    const espacios = ' '.repeat(finalTotalCharacters);
    return espacios + text;
};

export const convertTwipsToPixels = (twips: number): number => Math.round(twips / 15);

export const mapDataTypeToDevExpressDataType = (tipoDato: number | string): string => {
  const num = typeof tipoDato === 'string' ? parseInt(tipoDato, 10) : tipoDato;
  switch (num) {
    case 5:  // FlexDTDouble
    case 6:  // FlexDTCurrency
      return 'number';
    case 7:  // FlexDTDate
      return 'date';
    case 8:  // FlexDTString
      return 'string';
    case 11: // FlexDTBoolean
      return 'boolean';
    default:
      return 'string';
  }
};